// extracted by mini-css-extract-plugin
export default {"control":"Product_control__oJp9K","richText":"Product_richText__awlxN"};